<template>
  <div>
    <el-card class="box-card" body-style="min-height:74vh;">
      <div slot="header" class="clearfix">
        <el-form :model="searchForm" ref="searchForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="分类搜索：" prop="name">
            <el-input class="mt-search-width" v-model="searchForm.name" placeholder="请输入分类名称搜索"></el-input>
            <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="toAdd('')" size="small" type="primary" class="bg-theme">添加分类</el-button>
      </div>
      <div class="text item">
        <el-table
          border
          :data="infoList">
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="categoryName"
            label="分类名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="journeyBaseName"
            label="基地名称">
          </el-table-column>
          <el-table-column
            align="center"
            label="状态">
            <template slot-scope="scope">
              <el-switch
                v-if="isJourneyUser == 1"
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#CCCCCC"
                @change="switchChangeBtn(scope.row.id)">
              </el-switch>
              <span v-if="isJourneyUser == 0">{{scope.row.status ? '开启' : '禁用'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="updateTime"
            label="更新时间">
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="toAdd(scope.row.id)" type="text" size="small">编辑</el-button>
              <el-button v-if="isJourneyUser == 1" @click="delBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <el-dialog
      title="添加分类"
      :visible.sync="dialogVisible"
      width="960px">
      <el-form :model="cateForm" :rules="cateRules" label-width="140px">
        <el-form-item v-if="isJourneyUser == 0" label="选择基地：" prop="journeyBaseId">
          <el-select style="width: 420px;" v-model="cateForm.journeyBaseId" placeholder="请选择基地">
            <el-option v-for="(item,index) in baseList" :key="index" :label="item.baseName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="分类名称：" prop="categoryName">
          <el-input style="width: 420px;" v-model="cateForm.categoryName" placeholder="请输入分类名称"></el-input>
        </el-form-item>
        <el-form-item label="是否开启：" prop="status">
          <el-switch
            v-model="cateForm.status"
            active-color="#1890FF"
            inactive-color="#CCCCCC">
          </el-switch>
        </el-form-item>
        <el-form-item label="排序：" prop="sort">
          <el-input style="width: 420px;" v-model="cateForm.sort" placeholder="请输入排序(默认1)"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { querySeleniumJourneyVideoCategoryPageList, removeSeleniumJourneyVideoCategoryById, updateCategoryStatus, fetchSeleniumJourneyVideoCategoryDetailById, saveSeleniumJourneyVideoCategory, updateSeleniumJourneyVideoCategory, queryAllSeleniumJourneyBaseList } from '@/api/xyj'
export default {
  name: 'XyjVideoCate',
  data () {
    return {
      imgServer: this.$imgServer,
      limitLength: this.$limitLength,
      pageTotal: 0,
      currentPage: 1,
      infoList: [],
      fullscreenLoading: false,
      searchForm: {
        name:''
      },
      // 一级分类数据
      dataId:'',
      dialogVisible: false,
      cateForm:{
        journeyBaseId:'',
        categoryName:'',
        status:true,
        sort:''
      },
      cateRules: {
        journeyBaseId: [
          { required: true, message: '请选择基地', trigger: 'blur' }
        ],
        categoryName: [
          { required: true, message: '请输入分类名称', trigger: 'blur' }
        ]
      },
      // isJourneyUser 是否属于基地账户 0-否 1-是
      isJourneyUser:1,
      baseList:[]
    }
  },
  mounted () {
    var isJourneyUser = sessionStorage.getItem('isJourneyUser');
    this.isJourneyUser = isJourneyUser;
    this.getInfoList()
    if(isJourneyUser == 0){
      this.baseListInfoFun();
    }
  },
  methods: {
    // 获取基地列表
    baseListInfoFun(){
      var that = this;
      queryAllSeleniumJourneyBaseList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.baseList = data
        }
      })
    },
    // 搜索操作
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      querySeleniumJourneyVideoCategoryPageList({ categoryName: searchName,pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          data.forEach(function(item){
            item.status = item.status == 1 ? true : false;
          });
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    },
    // 开启或禁用操作
    switchChangeBtn(infoId){
      let that = this
      updateCategoryStatus({ id: infoId}).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {}
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    /* 删除 */
    delBtn (infoId) {
      let that = this
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        removeSeleniumJourneyVideoCategoryById({ ids: [infoId]}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 跳转添加 */
    toAdd (dataId) {
      this.dataId = dataId
      this.cateForm.journeyBaseId = '';
      this.cateForm.categoryName = '';
      this.cateForm.sort = '';
      if(dataId != ''){
        let that = this
        fetchSeleniumJourneyVideoCategoryDetailById({ id: dataId }).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            that.cateForm.journeyBaseId = data.journeyBaseId
            that.cateForm.categoryName = data.categoryName
            that.cateForm.status = data.status == 1 ? true : false
            that.cateForm.sort = data.sort
          }
        })
      }
      this.dialogVisible = true
    },
    // 添加-编辑
    saveBtn(){
      var that = this
      var dataId = that.dataId
      var journeyBaseId = that.cateForm.journeyBaseId
      var categoryName = that.cateForm.categoryName
      var status = that.cateForm.status ? 1 : 0
      var sort = that.cateForm.sort == '' ? 1 : that.cateForm.sort
      if (journeyBaseId === '' && that.isJourneyUser === 0) {
        this.$message.error('请选择基地')
        return false
      }
      if (categoryName === '') {
        this.$message.error('请输入分类名称')
        return false
      }
      let passData = {
        journeyBaseId: journeyBaseId, categoryName: categoryName, status: status, sort: sort
      }
      if (dataId !== '') {
        passData = {
          id: dataId, journeyBaseId: journeyBaseId, categoryName: categoryName, status: status, sort: sort
        }
        updateSeleniumJourneyVideoCategory(passData).then((res) => {
          that.fullscreenLoading = false;
          if(res.errorCode == "0000"){
            that.cateForm.categoryName = '';
            that.cateForm.sort = '';
            that.dialogVisible=false;
            that.currentPage = 1;
            that.getInfoList();
          }
          if(res.errorCode == "1001"){
            that.$message.error(res.msg);
          }
        })
      }else{
        saveSeleniumJourneyVideoCategory(passData).then((res) => {
          that.fullscreenLoading = false;
          if(res.errorCode == "0000"){
            that.cateForm.categoryName = '';
            that.cateForm.sort = '';
            that.dialogVisible=false;
            that.currentPage = 1;
            that.getInfoList();
          }
          if(res.errorCode == "1001"){
            that.$message.error(res.msg);
          }
        })
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/xyj/VideoCate.vue